export enum RequirementStatus {
  Pending = 'PENDING',
  Fail = 'FAIL',
  Pass = 'PASS',
}
